import { documentationActions, schedulingTask, screeningAction } from 'src/redux/actions/constant';

const {
  CREATE_TASK_NOTE_SCHEDULING_REQUEST,
  CREATE_TASK_NOTE_SCHEDULING_SUCCESS,
  CREATE_TASK_NOTE_SCHEDULING_FAILURE,
  CREATE_TASK_NOTE_SCHEDULING_LOADING,
  CREATE_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

const initialState: object = {
  isTaskCreated: false,
  response: null,
  loader: false,
};

export const createTherapistTaskNoteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CREATE_TASK_NOTE_SCHEDULING_SUCCESS: {
      return {
        ...state,
        isTaskCreated: true,
        response: action.payload,
        loader: false,
      };
    }

    case CREATE_TASK_NOTE_SCHEDULING_FAILURE:
      return {
        ...state,
        isTaskCreated: false,
        response: action.payload,
        loader: false,
      };

    case CREATE_TASK_NOTE_SCHEDULING_LOADING:
      return {
        ...state,
        loader: true,
      };

    case CREATE_TASK_NOTE_SCHEDULING_RESET:
      return initialState;

    default:
      return state;
  }
};
